module.exports = __webpack_public_path__ + "img/intelligent04.8393dab1.png";